import { render } from 'preact'
import './styles/base.css'
import { schemaAnwenden, schemaLesen } from './lib/theme.js'
import { App } from './app.jsx'

schemaAnwenden(schemaLesen())

render(<App />, document.getElementById('app'))

// iOS Safari setzt :active nur, wenn irgendwo ein touchstart-Listener hängt.
// Ohne ihn gäbe es auf dem Telefon beim Antippen keinerlei Rückmeldung —
// Hover gilt dort nicht (DESIGN.md, Telefon). Passiv, damit Scrollen frei bleibt.
document.addEventListener('touchstart', () => {}, { passive: true })

// Nur im gebauten Betrieb — im Entwicklungsbetrieb würde der Puffer die
// Aktualisierung durch Vite behindern.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Ohne Service Worker läuft die App normal weiter, nur nicht installierbar.
    })
  })
}
